import React from "react"

import { getIconSize } from "utils/get-icon-size"

export function WalletConnect({
  fill = "#2fa0f5",
  h = 24,
  w = 24,
  className,
}: {
  fill?: string
  h?: string | number
  w?: string | number
  className?: string
}) {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`w-[${getIconSize(w)}] h-[${getIconSize(h)}] ${className}`}
    >
      <rect width="24" height="24" fill="none" />
      <g clipPath="url(#clip0_5266_36883)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5.5C10.7525 5.5 9.51714 5.74573 8.36454 6.22315C7.36612 6.63671 6.44672 7.21711 5.64522 7.93839C5.43996 8.12311 5.44081 8.44078 5.63607 8.63604L7.05029 10.0503C7.24555 10.2455 7.56095 10.2439 7.77064 10.0642C8.29047 9.61876 8.87821 9.25755 9.51259 8.99478C10.3012 8.66813 11.1464 8.5 12 8.5C12.8536 8.5 13.6989 8.66813 14.4875 8.99478C15.1219 9.25755 15.7096 9.61876 16.2294 10.0642C16.4391 10.2439 16.7545 10.2455 16.9498 10.0503L18.364 8.63604C18.5593 8.44078 18.5601 8.12311 18.3549 7.93839C17.5534 7.21711 16.634 6.63671 15.6355 6.22314C14.4829 5.74572 13.2476 5.5 12 5.5ZM2.29293 12.7071C2.09767 12.9024 2.09767 13.219 2.29293 13.4142L6.93938 18.0607C7.52516 18.6464 8.47491 18.6464 9.0607 18.0607L11.6465 15.4749C11.8417 15.2796 12.1583 15.2796 12.3536 15.4749L14.9394 18.0607C15.5252 18.6464 16.4749 18.6464 17.0607 18.0607L21.7071 13.4142C21.9024 13.219 21.9024 12.9024 21.7071 12.7071L20.2929 11.2929C20.0977 11.0976 19.7811 11.0976 19.5858 11.2929L16.3536 14.5251C16.1583 14.7204 15.8417 14.7204 15.6465 14.5251L13.0607 11.9393C12.4749 11.3536 11.5252 11.3536 10.9394 11.9393L8.35359 14.5251C8.15833 14.7204 7.84175 14.7204 7.64649 14.5251L4.41425 11.2929C4.21899 11.0976 3.90241 11.0976 3.70714 11.2929L2.29293 12.7071Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_5266_36883">
          <rect width="19.7071" height="13" fill={fill} transform="translate(2.14648 5.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
